import React, { useState } from "react";
import styles from '../../styles/pstlandingpage.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Accordion from 'react-bootstrap/Accordion';
import LazyReveal from "../LazyReveal";

const FaqComponent: React.FC = (props: any) => {
  const [isViewMore, setIsViewMore] = useState<boolean>(false);
  const [showCardDetail, setShowCardDetail] = useState<string | null>(null);
  return (
    <LazyReveal className={styles.faqComponent} style={{ backgroundColor: props.sectionBgColor || "#EFEFFA" }}>
      <div>
        <Container>
          <Row>
            <div className={styles.heading}>
              <h2 className="text-center">{props.title}</h2>
              {props.description ? (
                <h4>{props.description}</h4>
              ) : (
                <>
                  <h4>{props.subTitle1}</h4>
                  <h4>{props.subTitle2}</h4>
                  <h3>{props.subTitle3}</h3>
                </>
              )}
            </div>
          </Row>
        </Container>
        <Container>
          <Row className={styles.content}>
            {props.faqPoints?.length > 0 &&
              props.faqPoints.map((faqsdata: any, index: number) => {
                const condition = !isViewMore ? index < 5 : index >= 0
                const key = index.toString();
                return condition && (
                  <Col xl={8} lg={8} md={8} sm={8} xs={8} key={index}>
                    <Accordion activeKey={showCardDetail} 
                    >
                      <Accordion.Item className={styles.stuAccordion} eventKey={key}>
                        <Accordion.Header className={styles.accoHead}
                          onClick={() => {
                            if (showCardDetail === key) {
                              setShowCardDetail(null);
                            } else {
                              setShowCardDetail(key);
                            }
                          }} >
                          <span style={{ color: ` ${showCardDetail === key ? "#0c63e4" : '#201f22'}` }}> {faqsdata.title}</span> </Accordion.Header>
                        <Accordion.Body className={styles.accorBody}>
                          <div dangerouslySetInnerHTML={{ __html: faqsdata.description }}></div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                )
              })
            }
          </Row>
          {props.faqPoints?.length > 5 && !isViewMore && <Row className='text-center'>
            <div className='mt-4 mb-3'>
              <a
                id='faq-component'
                onClick={() => {
                  setIsViewMore(true);
                }}
                className={styles.viewMore}
              >
                View More
              </a>
            </div>
          </Row>}
        </Container>
      </div >
    </LazyReveal >
  )
}
export default FaqComponent;